"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Breadcrumb;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RenderIf = _interopRequireDefault(require("../RenderIf"));

var _anchor = _interopRequireDefault(require("./styled/anchor"));

var _button = _interopRequireDefault(require("./styled/button"));

var _li = _interopRequireDefault(require("./styled/li"));

/* eslint-disable no-script-url */

/**
 * An item in the hierarchy path of the page the user is on.
 * @category Layout
 */
function Breadcrumb(props) {
  var href = props.href,
      label = props.label,
      onClick = props.onClick,
      disabled = props.disabled,
      className = props.className,
      style = props.style;
  return /*#__PURE__*/_react["default"].createElement(_li["default"], {
    className: className,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: href
  }, /*#__PURE__*/_react["default"].createElement(_anchor["default"], {
    disabled: disabled,
    href: href,
    "aria-disabled": !!disabled
  }, label)), /*#__PURE__*/_react["default"].createElement(_RenderIf["default"], {
    isTrue: onClick && !href
  }, /*#__PURE__*/_react["default"].createElement(_button["default"], {
    disabled: disabled,
    onClick: onClick,
    "aria-disabled": !!disabled
  }, label)));
}

Breadcrumb.propTypes = {
  /** The text label for the breadcrumb. */
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),

  /** The URL of the page that the breadcrumb goes to. */
  href: _propTypes["default"].string,

  /** The action triggered when the breadcrumb is clicked. */
  onClick: _propTypes["default"].func,

  /** Specifies that a breadcrumb element should be disabled. This value defaults to false. */
  disabled: _propTypes["default"].bool,

  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object
};
Breadcrumb.defaultProps = {
  label: undefined,
  href: undefined,
  onClick: function onClick() {},
  disabled: false,
  className: undefined,
  style: undefined
};